import { z } from 'zod'
import { Timestamp } from './common.js'

export const SavedSearch = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  name: z.string().min(1).max(100),
  query: z.record(z.string(), z.string()),
  created_at: Timestamp,
  last_seen_at: Timestamp.optional(),
})
export type SavedSearch = z.infer<typeof SavedSearch>

export const SavedSearchCreateInput = SavedSearch.pick({ name: true, query: true })
export type SavedSearchCreateInput = z.infer<typeof SavedSearchCreateInput>
